//#region components/split_button/split_button_constants.js
var e = {
	xs: "100",
	sm: "100",
	md: "200",
	lg: "200",
	xl: "300"
}, t = { SPLIT_BUTTON_ICON_SIZES: e };
//#endregion
export { e as SPLIT_BUTTON_ICON_SIZES, t as default };

//# sourceMappingURL=split-button-constants.js.map